
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/te-doen/[slug]",
      function () {
        return require("private-next-pages/te-doen/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/te-doen/[slug]"])
      });
    }
  